export default __webpack_public_path__ + "static/media/gridImage1.d0958c27.png";